import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { DetailsSuccessModal } from '../details-success-modal/details-success-modal.component';
import { RequestApprovalModalComponent } from '../request-approval-modal/request-approval-modal.component';

@Component({
  selector: 'weaccess-update-detail-modal',
  templateUrl: './update-detail-modal.component.html',
  styleUrls: ['./update-detail-modal.component.scss']
})
export class UpdateDetailModalComponent {

  globalConstants = GlobalConstants;
  radioValue = 'personalInfo';
  personalRadioStatus = false;
  docName = '+ UPLOAD PROOF';
  startJobDate!: Date;
  startDepartmentDate!: Date;
  startManagerDate!: Date;
  suspensionJobDate!: Date;
  revocationJobDate!: Date;
  terminationJobDate!: Date;
  accessData: any;
  stateData: any;
  programData: any;
  managerData: any;
  personalDetails = [
    {
      'name': 'Last Name',
      'id': 1
    },
    {
      'name': 'Contact Information',
      'id': 2
    }
  ];
  dateTypeData = [
    {
      'name': 'Job Title',
      'id': 1
    },
    {
      'name': 'Suspension Date',
      'id': 3
    },
    {
      'name': 'Termination Date',
      'id': 4
    }
  ];

  personalDataForm!: FormGroup;
  jobDataForm!: FormGroup;
  programDataForm!: FormGroup;
  managerDataForm!: FormGroup;
  approvalFlag: boolean = true;
  formValidFlag: any;
  staffName: any;
  staffData: any;
  minStartDate: any = new Date();
  managerUpdateSubscription!: Subscription;
  programUpdateSubscription!: Subscription;
  jobUpdateSubscription!: Subscription;
  jobTerminateDateSubscription!: Subscription;
  jobSuspensionDateSubscription!: Subscription;
  jobRevocateDateSubscription!: Subscription;
  staffDataSubscription!: Subscription;
  staffDetailsSubscription!: Subscription;
  contactUpdateSubscription!: Subscription;
  nameUpdateSubscription!: Subscription;
  programDataSubscription!: Subscription;
  supervisorDataSubscription!: Subscription;
  submitPopup: any;
  staffDetailsData: any;
  contactUpdateList: any = [];
  personalStateData: any;
  jobMinDate: any;
  programMinDate: any;
  managerMinDate: any;
  isJobDataChange: boolean = false;
  isProgramChange: boolean = false;
  isManagerChange: boolean = false;
  isUpdateFlag: boolean = true;
  updateRadioOption: any;
  infoData: any;
  currentManagerName: any;
  userRole: any;
  nonEmployeeFlag: boolean = false;
  uploadProof: any;
  isZipCodeValid: any;
  isEmployee: boolean = false;
  updateDetailShow: boolean = true;


  constructor(
    private bsModalRef: BsModalRef,
    private confirmModelRef: BsModalRef,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private commonService: CommonService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.userRole = localStorage.getItem(GlobalConstants?.USER_ROLE_KEY);
    this.userRole = JSON.parse(window.atob(this.userRole));
    if (this.userRole?.includes(this.globalConstants.ROLE_NON_EMPLOYEE)) {
      this.nonEmployeeFlag = true;
    }
    this.accessData = this.modalService.config.initialState;
    /** Based on request displaying the dropdown options */
    if (this.accessData?.data?.requestType === this.globalConstants?.SUSPENSION_DATE_UPDATE_DET_MODAL
      || this.accessData?.data?.requestType === this.globalConstants?.REVOCATION_DATE_UPDATE_DET_MODAL
      || this.accessData?.data?.requestType === this.globalConstants?.TERMINATION_DATE_UPDATE_DET_MODAL) {
      this.isUpdateFlag = false;
      this.updateRadioOption = 'jobInfo';
      this.onItemChange('jobInfo');
      if (this.accessData?.data?.requestType === this.globalConstants?.SUSPENSION_DATE_UPDATE_DET_MODAL) {
        this.dateTypeData = [
          {
            'name': 'Suspension Date',
            'id': 3
          }
        ];
      } else if (this.accessData?.data?.requestType === this.globalConstants?.REVOCATION_DATE_UPDATE_DET_MODAL) {
        this.dateTypeData = [
          {
            'name': 'Revocation Date',
            'id': 2
          }
        ];
      } else if (this.accessData?.data?.requestType === this.globalConstants?.TERMINATION_DATE_UPDATE_DET_MODAL) {
        this.dateTypeData = [
          {
            'name': 'Termination Date',
            'id': 4
          }
        ];
      }
      this.infoData = {
        dateType: this.dateTypeData ? this.dateTypeData?.filter((d: any) => d?.name === this.accessData?.data?.requestType)[0].id : null
      }
    } else {
      this.isUpdateFlag = true;
    }
    this.managerData = this.accessData?.data?.optionsDetailData?.managerData;
    this.programData = this.accessData?.data?.optionsDetailData?.programData;
  }

  async ngOnInit() {
    this.getRequestFormOptions();
    this.getStaffNameData();
    this.personalDataForm = this.fb.group({
      personalDetailType: [],
      lastName: [],
      primaryEmail: [, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      primaryPhone: [, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      primaryAddress: [, [Validators.required]],
      apartment: [],
      city: [, [Validators.required]],
      state: [, [Validators.required]],
      zipcode: [],
      country: [{ value: '', disabled: true }]
    });
    this.jobDataForm = this.fb.group({
      dateType: [, [Validators.required]],
      jobTitle: [, [Validators.required]],
      startJobDate: [, [Validators.required]],
      suspensionJobDate: [],
      revocationJobDate: [],
      terminationJobDate: []
    });
    this.programDataForm = this.fb.group({
      programName: [, Validators.required],
      startProgramDate: [, Validators.required]
    });
    this.managerDataForm = this.fb.group({
      managerName: [, Validators.required],
      startManagerDate: [, Validators.required]
    });
    if (this.accessData?.data) {
      this.setPersonalInformation();
      this.setUpdateDetails();
    }
  }

  /** Auto populate personal information details into form */
  setPersonalInformation() {
    let addressData = this.accessData?.data?.personData?.addressDetail;
    let stateValue: any;
    this.personalStateData = addressData?.stateProvince ? this.stateData?.filter((s: any) => s.stateName === addressData?.stateProvince)[0] : null
    if (this.personalStateData?.stateId) {
      stateValue = this.personalStateData?.stateId
    } else {
      stateValue = this.stateData?.filter((s: any) => s.stateName === 'Texas')[0].stateId;
    }
    let contactFormData = {
      lastName: this.accessData?.data?.personData?.lastName,
      state: stateValue,
      country: this.globalConstants?.REQ_COUNTRY,
      primaryEmail: addressData?.personalemail,
      primaryPhone: addressData?.personalphone,
      primaryAddress: addressData?.addressLine1,
      apartment: addressData?.addressLine2,
      city: addressData?.city,
      zipcode: addressData?.postalCode
    }
    this.personalDataForm?.patchValue(contactFormData);
    if (this.accessData?.data?.personData?.jobDetail?.employeeID && this.accessData?.data?.personData?.jobDetail?.employeeID !== "0" && this.accessData?.data?.personData?.jobDetail?.employeeID !== "null") {
      this.isEmployee = true;
    } else {
      this.isEmployee = false;
    }
  }

  /** Auto populate job/program/manager information details into form */
  setUpdateDetails() {
    if (this.accessData?.data?.personFlag === 'true') {
      let jobFormData = {
        jobTitle: this.accessData?.data?.personData?.jobDetail?.title,
      }
      this.jobMinDate = new Date(this.accessData?.data?.personData?.jobDetail?.startDate);
      this.jobDataForm?.patchValue(jobFormData);
      if (!this.isUpdateFlag) {
        this.jobDataForm?.patchValue(this.infoData);
      }
      let programFormData = {
        programName: this.programData?.filter((s: any) => s.programName === this.accessData?.data?.personData?.departmentDetail?.programName)[0]?.programId,
      }
      this.programMinDate = new Date(this.accessData?.data?.personData?.departmentDetail?.startDate);
      this.programDataForm?.patchValue(programFormData);
      this.managerMinDate = new Date(this.accessData?.data?.personData?.jobDetail?.startDate);
      this.currentManagerName = this.accessData?.data?.personData?.jobDetail?.supervisor;
    }
  }


  /** Get staff name data from API */
  getStaffNameData() {
    this.staffDataSubscription = this.commonService.getStaffData('').subscribe((staffNameListData: any) => {
      this.staffData = staffNameListData?.filter((item: any) => item?.isEmployee === false);
    }, (error: any) => {
    });
  }

  /** Get staff personal details from API */
  getStaffDetails() {
    let personReqParam = {
      personId: this.staffName ? this.staffName : 0
    }
    this.staffDetailsSubscription = this.commonService.getPersonalDetails(personReqParam).subscribe((staffDetailsData: any) => {
      this.staffDetailsData = staffDetailsData;
      this.getDropdownData(staffDetailsData);
    }, (error: any) => {
    });
  }

  /** Set job/program/manager details into form */
  setPersonDetails(staffDetailsData: any) {
    let jobFormData = {
      jobTitle: staffDetailsData.jobDetail?.title,
    }
    this.jobMinDate = new Date(staffDetailsData?.jobDetail?.startDate);
    this.jobDataForm?.patchValue(jobFormData);
    let programFormData = {
      programName: this.programData?.filter((s: any) => s.programName === staffDetailsData?.departmentDetail?.programName)[0]?.programId,
    }
    this.programMinDate = new Date(staffDetailsData?.departmentDetail?.startDate);
    this.programDataForm?.patchValue(programFormData);
    this.managerMinDate = new Date(staffDetailsData?.jobDetail?.startDate);
    this.currentManagerName = staffDetailsData?.jobDetail?.supervisor;
  }

  /** Get dropdown data from API*/
  async getDropdownData(staffDetailsData: any) {
    let programReqParams = {
      departmentId: 0
    }
    this.programDataSubscription = await this.commonService.getProgramData(programReqParams).subscribe((programData: any) => {
      this.programData = programData;
      this.getSupervisorData(staffDetailsData);
    }, (error: any) => {
      this.getSupervisorData(staffDetailsData);
    });
  }

  /** Get supervisor data from API */
  async getSupervisorData(staffDetailsData: any) {
    let managerReqParams = {
      departmentId: staffDetailsData?.departmentDetail?.departmentId
    }
    this.supervisorDataSubscription = await this.commonService.getSuperVisorData(managerReqParams).subscribe((supervisorData: any) => {
      this.managerData = supervisorData;
      this.setPersonDetails(staffDetailsData);
    }, (error: any) => {
      this.setPersonDetails(staffDetailsData);
    });
  }

  /** Onchange event listener */
  ngOnChanges() {
    this.formChangeValidation();
    if (!this.isUpdateFlag) {
      this.updateRadioOption = 'jobInfo';
    }
  }


  /** Getting field dropdown options from common services */
  getRequestFormOptions() {
    let OptionsData = this.commonService.getOptionsData();
    this.stateData = OptionsData['stateData'];
  }

  /** Based on request type field display*/
  getFieldDisplayStatus() {
    if (this.accessData?.data?.personFlag === 'true') {
      return true;
    } else if (this.accessData?.data?.personFlag === 'false') {
      if (this.staffName) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  /** Getting form valid status for update button enable/disable */
  formValidStatus() {
    if (this.radioValue === 'jobInfo' && this.jobDataForm?.valid) {
      return false;
    } else if (this.radioValue === 'programInfo' && this.programDataForm.valid) {
      return false;
    } else if (this.radioValue === 'managerInfo' && this.managerDataForm.valid) {
      return false;
    } else {
      return true;
    }
  }

  /** Removing the field from update personal information fields array */
  removeItem(array: any, itemValue: any) {
    const index = array.indexOf(itemValue);
    if (index > -1) {
      array.splice(index, 1);
      this.contactUpdateList = array;
    }
  }

  /** job title/ program / manager data change event functionality implementation*/
  optionChangeEvent(updateType: any) {
    if (updateType === 'Manager') {
      let previousManagerVal = ''
      let previousManagerDate: any;
      if (this.accessData?.data?.personFlag === 'true') {
        previousManagerVal = this.managerData?.filter((s: any) => s.fullName === this.accessData?.data?.personData?.jobDetail?.supervisor)[0]?.personId;
        previousManagerDate = new Date(this.accessData?.data?.personData?.jobDetail?.startDate);
      } else if (this.accessData?.data?.personFlag === 'false') {
        previousManagerVal = this.managerData?.filter((s: any) => s.fullName === this.staffDetailsData?.jobDetail?.supervisor)[0]?.personId;
        previousManagerDate = new Date(this.staffDetailsData?.jobDetail?.startDate);
      }
      if (previousManagerVal !== this.managerDataForm.value['managerName']) {
        this.isManagerChange = true;
        let managerFormData = {
          startManagerDate: null
        }
        this.managerDataForm?.patchValue(managerFormData);
        this.approvalFlag = true;
      } else {
        this.isManagerChange = false;
      }
    } else if (updateType === 'Program') {
      let previousProgramVal = '';
      let previousProgramDate: any;
      if (this.accessData?.data?.personFlag === 'true') {
        previousProgramVal = this.programData?.filter((s: any) => s.programName === this.accessData?.data?.personData?.departmentDetail?.programName)[0]?.programId;
        previousProgramDate = new Date(this.accessData?.data?.personData?.departmentDetail?.startDate);
      } else if (this.accessData?.data?.personFlag === 'false') {
        previousProgramVal = this.programData?.filter((s: any) => s.programName === this.staffDetailsData?.departmentDetail?.programName)[0]?.programId;
        previousProgramDate = new Date(this.staffDetailsData?.departmentDetail?.startDate);
      }
      if (previousProgramVal !== this.programDataForm.value['programName']) {
        this.isProgramChange = true;
        let programFormData = {
          startProgramDate: null
        }
        this.programDataForm?.patchValue(programFormData);
        this.approvalFlag = true;
      } else {
        this.isProgramChange = false;
      }
    } else if (updateType === 'JobTitle') {
      let previousJobTitleVal = '';
      let previousJobDate: any;
      if (this.accessData?.data?.personFlag === 'true') {
        previousJobTitleVal = this.accessData?.data?.personData?.jobDetail?.title;
        previousJobDate = new Date(this.accessData?.data?.personData?.jobDetail?.startDate);
      } else if (this.accessData?.data?.personFlag === 'false') {
        previousJobTitleVal = this.staffDetailsData?.jobDetail?.title;
        previousJobDate = new Date(this.staffDetailsData?.jobDetail?.startDate);
      }
      if (previousJobTitleVal !== this.jobDataForm?.value['jobTitle']) {
        this.isJobDataChange = true;
        let jobFormVal = {
          startJobDate: null
        }
        this.jobDataForm?.patchValue(jobFormVal);
        this.approvalFlag = true;
      } else {
        this.isJobDataChange = false;
      }
    }
  }

  /** Date type change event for field display */
  dateTypeChange() {
    if (this.jobDataForm?.value['dateType'] && this.jobDataForm?.value['dateType'] === 1) {
      let jobData = {
        jobTitle: ''
      }
      if (this.accessData?.data?.personFlag === 'true') {
        jobData['jobTitle'] = this.accessData?.data?.personData?.jobDetail?.title;
      } else if (this.accessData?.data?.personFlag === 'false') {
        jobData['jobTitle'] = this.staffDetailsData?.jobDetail?.title;
      }
      this.jobDataForm?.patchValue(jobData);
    }
  }

  /** Form change validation for check each field dirty and return status */
  formChangeValidation() {
    if (this.radioValue === 'personalInfo') {
      if (this.personalDataForm.value['personalDetailType'] === 1) {
        this.approvalFlag = true;
        if (this.personalDataForm.value['lastName'] && this.accessData?.data?.personData?.lastName != this.personalDataForm.value['lastName']) {
          this.approvalFlag = false;
        } else {
          this.docName = "+ UPLOAD PROOF";
          this.approvalFlag = true;
        }
      } else if (this.personalDataForm.value['personalDetailType'] === 2) {
        this.approvalFlag = true;
        if (this.personalDataForm.value['primaryEmail'] && this.accessData?.data?.personData?.addressDetail?.personalemail !== this.personalDataForm.value['primaryEmail']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('PersonalEmail');
        } else {
          this.removeItem(this.contactUpdateList, 'PersonalEmail');
        }
        if (this.personalDataForm.value['primaryPhone'] && this.accessData?.data?.personData?.addressDetail?.personalphone !== this.personalDataForm.value['primaryPhone']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('PersonalPhone');
        } else {
          this.removeItem(this.contactUpdateList, 'PersonalPhone');
        }
        if (this.personalDataForm.value['primaryAddress'] && this.accessData?.data?.personData?.addressDetail?.addressLine1 !== this.personalDataForm.value['primaryAddress']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('AddressLine1');
        } else {
          this.removeItem(this.contactUpdateList, 'AddressLine1');
        }
        if (this.personalDataForm.value['apartment'] && this.accessData?.data?.personData?.addressDetail?.addressLine2 !== this.personalDataForm.value['apartment']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('AddressLine2');
        } else {
          this.removeItem(this.contactUpdateList, 'AddressLine2');
        }
        if (this.personalDataForm.value['city'] && this.accessData?.data?.personData?.addressDetail?.city !== this.personalDataForm.value['city']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('City');
        } else {
          this.removeItem(this.contactUpdateList, 'City');
        }
        if (this.personalDataForm.value['state'] && this.personalStateData?.stateId !== this.personalDataForm.value['state']) {
          this.approvalFlag = false;
          this.contactUpdateList.push('StateID');
        } else {
          this.removeItem(this.contactUpdateList, 'StateID');
        }
        this.contactUpdateList = [...new Set(this.contactUpdateList)];
      }

    } else if (this.radioValue === 'jobInfo') {
      this.approvalFlag = true;
      if (this.jobDataForm?.value['dateType'] === 1 && this.jobDataForm?.valid) {
        if (this.accessData?.data?.personFlag === 'true') {
          if (this.jobDataForm?.value['jobTitle'].toString().trim().length > 0 && this.accessData?.data?.personData?.jobDetail?.title !== this.jobDataForm?.value['jobTitle']) {
            this.approvalFlag = false;
          } else {
            this.approvalFlag = true;
          }
        } else if (this.accessData?.data?.personFlag === 'false') {
          if (this.jobDataForm?.value['jobTitle'].toString().trim().length > 0 && this.staffDetailsData?.jobDetail?.title !== this.jobDataForm?.value['jobTitle']) {
            this.approvalFlag = false;
          } else {
            this.approvalFlag = true;
          }
        }
      } else if (this.jobDataForm?.value['dateType'] === 2) {
        if (this.jobDataForm?.value['revocationJobDate']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      } else if (this.jobDataForm?.value['dateType'] === 3) {
        if (this.jobDataForm?.value['suspensionJobDate']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      } else if (this.jobDataForm?.value['dateType'] === 4) {
        if (this.jobDataForm?.value['terminationJobDate']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      } else {
        this.approvalFlag = true;
      }
    } else if (this.radioValue === 'programInfo' && this.programDataForm.valid) {
      this.approvalFlag = true;
      if (this.accessData?.data?.personFlag === 'true') {
        let previousProgramVal = this.programData?.filter((s: any) => s.programName === this.accessData?.data?.personData?.departmentDetail?.programName)[0]?.programId
        if (previousProgramVal !== this.programDataForm.value['programName']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      } else if (this.accessData?.data?.personFlag === 'false') {
        let previousProgramVal = this.programData?.filter((s: any) => s.programName === this.staffDetailsData?.departmentDetail?.programName)[0]?.programId
        if (previousProgramVal !== this.programDataForm.value['programName']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      }
    } else if (this.radioValue === 'managerInfo' && this.managerDataForm.valid) {
      this.approvalFlag = true;
      if (this.accessData?.data?.personFlag === 'true') {
        let previousManagerVal = this.managerData?.filter((s: any) => s.fullName === this.accessData?.data?.personData?.jobDetail?.supervisor)[0]?.personId;
        if (previousManagerVal !== this.managerDataForm.value['managerName']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      } else if (this.accessData?.data?.personFlag === 'false') {
        let previousManagerVal = this.managerData?.filter((s: any) => s.fullName === this.staffDetailsData?.jobDetail?.supervisor)[0]?.personId
        if (previousManagerVal !== this.managerDataForm.value['managerName']) {
          this.approvalFlag = false;
        } else {
          this.approvalFlag = true;
        }
      }
    } else {
      this.approvalFlag = true;
    }
  }

  /** Get button enable status based on field type selection */
  getBtnEnableStatus() {
    if (this.personalDataForm.value['personalDetailType'] === 1) {
      if (!this.approvalFlag && this.docName && this.docName != "+ UPLOAD PROOF" && this.personalDataForm.value['lastName']) {
        return false;
      } else {
        return true;
      }
    } else if (this.personalDataForm.value['personalDetailType'] === 2) {
      if (this.personalDataForm.valid) {
        return this.approvalFlag;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  /** Clear button click event - Clears the current tab form values when this events triggers */
  clearForm() {
    if (this.radioValue == 'personalInfo') {
      this.personalDataForm.reset();
      this.setPersonalInformation();
      this.approvalFlag = true;
    } else if (this.radioValue == 'jobInfo') {
      this.staffName = null;
      this.jobDataForm.reset();
    } else if (this.radioValue == 'programInfo') {
      this.staffName = null;
      this.programDataForm.reset();
    } else if (this.radioValue == 'managerInfo') {
      this.staffName = null;
      this.managerDataForm.reset();
    }
  }

  /** Radio button change  */
  onItemChange(e: any) {
    this.radioValue = e;
    if (this.accessData?.data?.personFlag === 'true') {
      this.setUpdateDetails();
      if (this.radioValue == 'jobInfo') {
        let jobVal = {
          dateType: null
        }
        this.jobDataForm?.patchValue(jobVal);
        this.isJobDataChange = false;
      } else if (this.radioValue == 'programInfo') {
        this.isProgramChange = false;
      } else if (this.radioValue == 'managerInfo') {
        this.isManagerChange = false;
      }
    } else if (this.accessData?.data?.personFlag === 'false') {
      this.staffName = null;
      if (this.radioValue == 'jobInfo') {
        this.staffName = null;
        this.jobDataForm.reset();
        this.isJobDataChange = false;
        let jobVal = {
          dateType: null
        }
        this.jobDataForm?.patchValue(jobVal);
      } else if (this.radioValue == 'programInfo') {
        this.staffName = null;
        this.programDataForm.reset();
        this.isProgramChange = false;
      } else if (this.radioValue == 'managerInfo') {
        this.staffName = null;
        this.managerDataForm.reset();
        this.isManagerChange = false;
      }
    }
    if (this.radioValue == 'personalInfo') {
      this.personalRadioStatus = true;
      this.setPersonalInformation();
    }
    this.formChangeValidation();
  }

  /** Modal Close */
  onClose() {
    this.bsModalRef.hide();
  }

  /** Input file (Document upload) change event and validation */
  showName(e: any) {
    if (e.target.files.length > 0) {
      this.docName = e.target.files[0].name;
      var extension = this.docName?.substring(this.docName.lastIndexOf('.'));
      if ((extension.toLowerCase() == ".pdf") ||
        (extension.toLowerCase() == ".jpg") || (extension.toLowerCase() == ".png") || (extension.toLowerCase() == ".jpeg")) {
        this.fileSizeValidation(e, e.target.files[0]);
      } else {
        this.openRequestSubmitPopup('Please select a valid file format', '',
          '', 'error', 'submitData', 'submitData');
        this.docName = "+ UPLOAD PROOF";
      }

    }
  }

  /** File size validation restrict max size as 2MB */
  fileSizeValidation(event: any, file: any) {
    const fileSize = file.size;
    const fileMb = fileSize / 1024 ** 2;
    if (fileMb >= 2) {
      this.openRequestSubmitPopup('Please select a file less than 2MB.', '',
        '', 'error', 'submitData', 'submitData');
      this.docName = "+ UPLOAD PROOF";
    } else {
      this.handleUpload(event)
    }
  }

  /** Covert the input file into base64 format */
  handleUpload(event: any) {
    this.uploadProof = '';
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.uploadProof = reader.result;
    };
  }


  /** Open confirmation modal implementation */
  openConfirmModal(type: any) {
    let updateReqType = '';
    if (type === 'jobInfo') {
      if (this.jobDataForm?.value['dateType'] === 1) {
        this.sendApprovalRequest(type);
      } else if (this.jobDataForm?.value['dateType'] === 2) {
        updateReqType = 'Revocation';
      } else if (this.jobDataForm?.value['dateType'] === 3) {
        updateReqType = 'Suspension';
      } else if (this.jobDataForm?.value['dateType'] === 4) {
        updateReqType = 'Termination';
      }

      if (updateReqType) {
        const modalData: any = {
          data: {
            'type': 'confirmRequest',
            'status': '',
            'requestType': updateReqType
          }
        }
        this.updateDetailShow = false;
        this.confirmModelRef = this.modalService.show(RequestApprovalModalComponent, {
          animated: true,
          backdrop: 'static',
          class: 'modal-lg modal-dialog-centered',
          initialState: modalData
        });
        this.confirmModelRef.onHide?.subscribe((res: any) => { });

        this.confirmModelRef.content.requestApprovalEvent.subscribe((data: any) => {
          if (data?.type === 'Cancel') {
            this.updateDetailShow = true;
          } else if (data?.type === 'ConfirmRequest') {
            this.updateDetailShow = true;
            this.sendApprovalRequest(type);
          }
        });
      }
    } else {
      this.sendApprovalRequest(type);
    }

  }

  /***Send for approval button Update request  event */
  sendApprovalRequest(requestType: any) {
    /** Personal information updation request submit API implementation */
    if (requestType === 'personalInfo') {
      let fileData = this.uploadProof?.split(',')[1];
      /** LastName updation request submit API implementation */
      if (this.personalDataForm.value['personalDetailType'] === 1 && this.personalDataForm?.value['lastName']) {
        let lastNameData = {
          "requestID": 0,
          "personId": 0,
          "fieldsName": "LastName",
          "fieldsValue": this.personalDataForm?.value['lastName'],
          "statusId": 1001,
          "lastModPersonID": 0,
          "reason": "",
          "fileData": fileData
        }

        this.nameUpdateSubscription = this.commonService.updateLastNameInformation(lastNameData, '').subscribe(() => {
          this.openRequestSubmitPopup('Lastname update request has been successfully submitted.', 'The request for approval is sent to HR.',
            'Please wait until it gets approved',
            'success', 'submitData', 'submitData');
          this.onClose();
        }, (error: any) => {
          if (error?.status === 409) {
            this.openRequestSubmitPopup(error?.error, '',
              '', 'error', 'submitData', 'submitData');
          } else {
            this.openRequestSubmitPopup('Error occurred in submitting lastname update request.', '',
              '', 'error', 'submitData', 'submitData');
          }
        });
      }
      /** Contact information updation request submit API implementation */
      else if (this.personalDataForm.valid && this.personalDataForm.value['personalDetailType'] === 2) {
        this.contactUpdateList = [...new Set(this.contactUpdateList)];
        if (this.contactUpdateList && this.contactUpdateList.length > 0) {
          let contactInfoData = {
            "requestID": 0,
            "personId": 0,
            "fieldsName": "",
            "fieldsValue": "",
            "statusId": 1001,
            "lastModPersonID": 0,
            "reason": ""
          }

          this.contactUpdateList.forEach((item: any) => {
            if (contactInfoData.fieldsName) {
              if (item === "PersonalEmail") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "PersonalEmail";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['primaryEmail'];
              } else if (item === "PersonalPhone") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "PersonalPhone";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['primaryPhone'];
              } else if (item === "AddressLine1") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "AddressLine1";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['primaryAddress'];
              } else if (item === "AddressLine2") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "AddressLine2";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['apartment'];
              } else if (item === "City") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "City";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['city'];
              } else if (item === "StateID") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "StateID";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['state'].toString();
              } else if (item === "PostalCode") {
                contactInfoData.fieldsName = contactInfoData.fieldsName + ',' + "PostalCode";
                contactInfoData.fieldsValue = contactInfoData.fieldsValue + ',' + this.personalDataForm.value['zipcode'];
              }
            } else {
              if (item === "PersonalEmail") {
                contactInfoData.fieldsName = "PersonalEmail";
                contactInfoData.fieldsValue = this.personalDataForm.value['primaryEmail'];
              } else if (item === "PersonalPhone") {
                contactInfoData.fieldsName = "PersonalPhone";
                contactInfoData.fieldsValue = this.personalDataForm.value['primaryPhone'];
              } else if (item === "AddressLine1") {
                contactInfoData.fieldsName = "AddressLine1";
                contactInfoData.fieldsValue = this.personalDataForm.value['primaryAddress'];
              } else if (item === "AddressLine2") {
                contactInfoData.fieldsName = "AddressLine2";
                contactInfoData.fieldsValue = this.personalDataForm.value['apartment'];
              } else if (item === "City") {
                contactInfoData.fieldsName = "City";
                contactInfoData.fieldsValue = this.personalDataForm.value['city'];
              } else if (item === "StateID") {
                contactInfoData.fieldsName = "StateID";
                contactInfoData.fieldsValue = this.personalDataForm.value['state'].toString();
              } else if (item === "PostalCode") {
                contactInfoData.fieldsName = "PostalCode";
                contactInfoData.fieldsValue = this.personalDataForm.value['zipcode'];
              }
            }
          })
          this.contactUpdateSubscription = this.commonService.updateContactInformation(contactInfoData, '').subscribe(() => {
            this.openRequestSubmitPopup('Personal information update request has been successfully submitted.', 'The request for approval is sent to HR.',
              'Please wait until it gets approved',
              'success', 'submitData', 'submitData');
            this.onClose();
          }, (error: any) => {
            if (error?.status === 409) {
              this.openRequestSubmitPopup(error?.error, '',
                '', 'error', 'submitData', 'submitData');
            } else {
              this.openRequestSubmitPopup('Error occurred in submitting Personal information update request.', '',
                '', 'error', 'submitData', 'submitData');
            }
          });
        }
      }
    }
    /** Job information updation request submit API implementation */
    else if (requestType === 'jobInfo') {
      if (this.jobDataForm?.value['dateType'] === 1) {
        let jobData = {
          "personId": this.accessData?.data?.personData?.personId,
          "startDt": formatDate(this.jobDataForm?.value['startJobDate'], 'yyyy-MM-dd', this.locale),
          "statusId": 1001,
          "modifiedPersonid": 0,
          "reason": "",
          "jobTitle": this.jobDataForm?.value['jobTitle']
        }
        if (this.accessData?.data?.personFlag === 'false') {
          jobData['personId'] = this.staffName;
        }
        this.jobUpdateSubscription = this.commonService.updateJobApproval(jobData, '').subscribe((data: any) => {
          this.openRequestSubmitPopup('Job Title update request has been successfully submitted.', 'The request for approval is sent to HR.',
            'Please wait until it gets approved',
            'success', 'submitData', 'submitData');
          this.onClose();
        }, (error: any) => {
          if (error?.status === 409) {
            this.openRequestSubmitPopup(error?.error, '',
              '', 'error', 'submitData', 'submitData');
          } else {
            this.openRequestSubmitPopup('Error occurred in submitting Job Title update request.', '',
              '', 'error', 'submitData', 'submitData');
          }
        });

      } else if (this.jobDataForm?.value['dateType'] === 2) {
        let jobDateDetails = {
          "personId": this.accessData?.data?.personData?.personId,
          "requestTypeId": 5002,
          "endDt": formatDate(this.jobDataForm?.value['revocationJobDate'], 'yyyy-MM-dd', this.locale),
          "statusId": 1001,
          "modifiedPersonid": 0,
          "reason": ""
        }
        if (this.accessData?.data?.personFlag === 'false') {
          jobDateDetails['personId'] = this.staffName;
        }
        this.jobRevocateDateSubscription = this.commonService.updateDateApproval(jobDateDetails, '').subscribe((data: any) => {
          this.openRequestSubmitPopup('Job Revocation date update request has been successfully submitted.', 'The request for approval is sent to HR.',
            'Please wait until it gets approved',
            'success', 'submitData', 'submitData');
          this.onClose();
        }, (error: any) => {
          if (error?.status === 409) {
            this.openRequestSubmitPopup(error?.error, '',
              '', 'error', 'submitData', 'submitData');
          } else {
            this.openRequestSubmitPopup('Error occurred in submitting Job Revocation date update request.', '',
              '', 'error', 'submitData', 'submitData');
          }
        });
      } else if (this.jobDataForm?.value['dateType'] === 3) {
        let jobDateDetails = {
          "personId": this.accessData?.data?.personData?.personId,
          "requestTypeId": 5003,
          "endDt": formatDate(this.jobDataForm?.value['suspensionJobDate'], 'yyyy-MM-dd', this.locale),
          "statusId": 1001,
          "modifiedPersonid": 0,
          "reason": ""
        }
        if (this.accessData?.data?.personFlag === 'false') {
          jobDateDetails['personId'] = this.staffName;
        }
        this.jobSuspensionDateSubscription = this.commonService.updateDateApproval(jobDateDetails, '').subscribe((data: any) => {
          this.openRequestSubmitPopup('Job Suspension date update request has been successfully submitted.', 'The request for approval is sent to HR.',
            'Please wait until it gets approved',
            'success', 'submitData', 'submitData');
          this.onClose();
        }, (error: any) => {
          if (error?.status === 409) {
            this.openRequestSubmitPopup(error?.error, '',
              '', 'error', 'submitData', 'submitData');
          } else {
            this.openRequestSubmitPopup('Error occurred in submitting Job Suspension date update request.', '',
              '', 'error', 'submitData', 'submitData');
          }
        });
      } else if (this.jobDataForm?.value['dateType'] === 4) {
        let jobDateDetails = {
          "personId": this.accessData?.data?.personData?.personId,
          "requestTypeId": 5004,
          "endDt": formatDate(this.jobDataForm?.value['terminationJobDate'], 'yyyy-MM-dd', this.locale),
          "statusId": 1001,
          "modifiedPersonid": 0,
          "reason": ""
        }
        if (this.accessData?.data?.personFlag === 'false') {
          jobDateDetails['personId'] = this.staffName;
        }
        this.jobTerminateDateSubscription = this.commonService.updateDateApproval(jobDateDetails, '').subscribe((data: any) => {
          this.openRequestSubmitPopup('Job Termination date update request has been successfully submitted.', 'The request for approval is sent to HR.',
            'Please wait until it gets approved',
            'success', 'submitData', 'submitData');
          this.onClose();
        }, (error: any) => {
          if (error?.status === 409) {
            this.openRequestSubmitPopup(error?.error, '',
              '', 'error', 'submitData', 'submitData');
          } else {
            this.openRequestSubmitPopup('Error occurred in submitting Job Termination date update request.', '',
              '', 'error', 'submitData', 'submitData');
          }
        });
      }
    }
    /** Program information updation request submit API implementation */
    else if (requestType === 'programInfo') {
      let programData = {
        "personId": this.accessData?.data?.personData?.personId,
        "startDt": formatDate(this.programDataForm.value['startProgramDate'], 'yyyy-MM-dd', this.locale),
        "statusId": 1001,
        "modifiedPersonid": 0,
        "reason": "",
        "programID": this.programDataForm.value['programName']
      }
      if (this.accessData?.data?.personFlag === 'false') {
        programData['personId'] = this.staffName;
      }
      this.programUpdateSubscription = this.commonService.updateProgramApproval(programData, '').subscribe((data: any) => {
        this.openRequestSubmitPopup('Program update request has been successfully submitted.', 'The request for approval is sent to HR.',
          'Please wait until it gets approved',
          'success', 'submitData', 'submitData');
        this.onClose();
      }, (error: any) => {
        if (error?.status === 409) {
          this.openRequestSubmitPopup(error?.error, '',
            '', 'error', 'submitData', 'submitData');
        } else {
          this.openRequestSubmitPopup('Error occurred in submitting Program update request.', '',
            '', 'error', 'submitData', 'submitData');
        }
      });
    }
    /** Manager information updation request submit API implementation */
    else if (requestType === 'managerInfo') {
      let managerData = {
        "personId": this.accessData?.data?.personData?.personId,
        "startDt": formatDate(this.managerDataForm.value['startManagerDate'], 'yyyy-MM-dd', this.locale),
        "statusId": 1001,
        "modifiedPersonid": 0,
        "reason": "",
        "managerPersonID": this.managerDataForm.value['managerName']
      }
      if (this.accessData?.data?.personFlag === 'false') {
        managerData['personId'] = this.staffName;
      }
      this.managerUpdateSubscription = this.commonService.updateManagerApproval(managerData, '').subscribe((data: any) => {
        this.openRequestSubmitPopup('Manager update request has been successfully submitted.', 'The request for approval is sent to HR.',
          'Please wait until it gets approved',
          'success', 'submitData', 'submitData');
        this.onClose();
      }, (error: any) => {
        if (error?.status === 409) {
          this.openRequestSubmitPopup(error?.error, '',
            '', 'error', 'submitData', 'submitData');
        } else {
          this.openRequestSubmitPopup('Error occurred in submitting Manager update request.', '',
            '', 'error', 'submitData', 'submitData');
        }
      });
    }
  }

  /** Open request submit popup implementation */
  openRequestSubmitPopup(message: string, subMessage: string, subSubMessage: string, type: string, status: string, actionType: string) {
    const modalData: any = {
      data: {
        'data': type,
        'message': message,
        'subMessage': subMessage,
        'subSubMessage': subSubMessage,
        'status': status,
        'actionType': actionType
      }
    }

    this.submitPopup = this.modalService.show(DetailsSuccessModal, {
      animated: true,
      backdrop: 'static',
      class: 'modal-dialog modal-dialog-centered modal-dialog-sweet-alert',
      initialState: modalData
    })

    this.submitPopup.onHide?.subscribe((res: any) => {
      if (modalData.data.data === 'success') {
        this.commonService.requestChangeItemHandler(true);
        this.commonService.countChangeItemHandler(true);
      }
    })
  }

  /** Listen to validation status from child */
  handleValidationStatus(status: any) {
    this.isZipCodeValid = status;
    if (this.personalDataForm.value['zipcode'] && this.accessData?.data?.personData?.addressDetail?.postalCode !== this.personalDataForm.value['zipcode'] && this.isZipCodeValid) {
      this.approvalFlag = false;
      if (!this.contactUpdateList?.includes('PostalCode')) {
        this.contactUpdateList.push('PostalCode');
      }
    } else {
      if (this.contactUpdateList?.length === 1) {
        this.approvalFlag = true;
      }
      if (this.contactUpdateList?.includes('PostalCode')) {
        this.removeItem(this.contactUpdateList, 'PostalCode');
      }
    }
  }
}
